// import * as actionTypes from './actionTypes';
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	user: {},
	isLoading: false,
	hasBeenLoaded: false,
	error: '',
	registerUser: {
		email: '',
		error: '',
		hasBeenLoaded: false,
		isLoading: false
	},
	subscription: {
		data: {},
		error: '',
		hasBeenLoaded: false,
		isLoading: false
	},
	updateUser: {
		error: '',
		hasBeenLoaded: false,
		isLoading: false
	}
};

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		getUser: (state) => {
			state.hasBeenLoaded = false;
			state.isLoading = true;
		},
		getUserCompleted: (state, action) => {
			state.isLoading = false;
			state.user = action.payload;
			state.hasBeenLoaded = true;
			state.error = '';
		},
		getUserFailed: (state, action) => {
			state.isLoading = false;
			state.hasBeenLoaded = false;
			state.error = action.payload;
		},
		getUserSubscription: (state) => {
			state.subscription.isLoading = true;
		},
		getUserSubscriptionCompleted: (state, action) => {
			state.subscription.isLoading = false;
			state.subscription.data = action.payload;
			state.subscription.hasBeenLoaded = true;
			state.subscription.error = '';
		},
		getUserSubscriptionFailed: (state, action) => {
			state.subscription.isLoading = false;
			state.subscription.hasBeenLoaded = false;
			state.subscription.error = action.payload;
		},
		registerUser: (state, action) => {
			state.registerUser.isLoading = true;
			state.registerUser.email = action.payload.email;
		},
		registerUserCompleted: (state, action) => {
			state.registerUser.isLoading = false;
			state.registerUser.hasBeenLoaded = true;
			state.registerUser.error = '';
		},
		registerUserFailed: (state, action) => {
			state.registerUser.isLoading = false;
			state.registerUser.hasBeenLoaded = false;
			state.registerUser.error = action.payload;
		},
		updateUser: (state) => {
			state.updateUser.isLoading = true;
		},
		updateUserCompleted: (state, action) => {
			state.updateUser.isLoading = false;
			state.updateUser.hasBeenLoaded = true;
			state.updateUser.error = '';
		},

		updateUserFailed: (state, action) => {
			state.updateUser.isLoading = false;
			state.updateUser.hasBeenLoaded = false;
			state.updateUser.error = action.payload;
		}
	}
});

export const {
	getUser,
	getUserCompleted,
	getUserFailed,
	getUserSubscription,
	getUserSubscriptionCompleted,
	getUserSubscriptionFailed,
	registerUser,
	registerUserCompleted,
	registerUserFailed,
	updateUser,
	updateUserCompleted,
	updateUserFailed
} = userSlice.actions;

export default userSlice.reducer;
